/* ============================================================
   Formatação de valores monetários — módulo único.

   Existiam seis implementações espalhadas pelas páginas, o que fazia com que
   corrigir uma não corrigisse as outras e que o mesmo ecrã pudesse mostrar
   "1234.56€" ao lado de "1 234,56 €".

   IMPORTANTE — isto formata APENAS o que é apresentado. O valor que entra nos
   cálculos e que vai para a base de dados nunca deve passar por aqui: o
   parseFloat do JavaScript pára no primeiro caráter que não pertença a um
   número simples, pelo que "1.234,56" seria lido como 1,234 — sem erro e sem
   aviso.
   ============================================================ */

// Separador de milhares inserido à mão, em vez de toLocaleString.
// O Intl não era fiável aqui: em português a regra CLDR só agrupa a partir dos
// 5 dígitos, pelo que 9483,30 saía sem separador e 10483,30 com ele — na mesma
// coluna. A opção que corrige isso mudou de significado entre versões do motor
// e o resultado dependia do browser. Assim é determinístico.
//
// Convenção portuguesa: ponto nos milhares, vírgula nos decimais.
// Alterar esta constante muda a apresentação em toda a aplicação.
const SEPARADOR_MILHARES = '.';

/** 9483.3 → "9.483,30" */
export const fmtValor = (v) => {
    const n = parseFloat(v);
    const seguro = Number.isFinite(n) ? n : 0;
    const negativo = seguro < 0;
    const [inteiro, decimal] = Math.abs(seguro).toFixed(2).split('.');
    const comMilhares = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, SEPARADOR_MILHARES);
    return `${negativo ? '-' : ''}${comMilhares},${decimal}`;
};

/** 252502 → "252.502" — inteiros com o mesmo separador de milhares do resto
 *  da aplicação. O toLocaleString('pt-PT') não serve: usa espaço em vez de
 *  ponto e não agrupa números de quatro dígitos, o que dava "3679" ao lado de
 *  "252 502" na mesma coluna. */
export const fmtInteiro = (v) => {
    const n = parseInt(v, 10);
    if (!Number.isFinite(n)) return '';
    const negativo = n < 0;
    const digitos = String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, SEPARADOR_MILHARES);
    return `${negativo ? '-' : ''}${digitos}`;
};

/** 9483.3 → "9.483,30 €" */
export const fmtMoney = (v) => `${fmtValor(v)} €`;

export default fmtMoney;
